import MiniCompletionCircle from "./MiniCompletionCircle"
export default MiniCompletionCircle
